import React, { useEffect } from 'react';
import { useBreadcrumbs } from 'src/state/breadcrumbs';
import { event } from '@uhg-abyss/web/tools/event';
import { ToolLink } from '../ToolLink';
import { PageBodyIntro } from '@workshop/common/PageBodyIntro';
import { PageLayout } from 'src/common/PageLayout';

const STYLES = {
  marginTop: '20px',
  marginBottom: '48px',
};
export const AdditionalToolsContent = () => {
  const { setBreadcrumbs, breadcrumbs } = useBreadcrumbs();
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    event.setData({ pageName: 'additionaltools' });
    setBreadcrumbs({
      id: 'additional-tools',
      title: 'Additional Tools',
      href: '/additional-tools',
    });
    event('ADDITIONAL_TOOLS_PAGE_LOAD');
  }, []);

  return (
    <>
      <PageBodyIntro title="Additional Tools" breadcrumbs={breadcrumbs} />
      <PageLayout style={STYLES}>
        <ToolLink />
      </PageLayout>
    </>
  );
};
